import React, { useMemo } from 'react';
import { useParams } from 'react-router';
import i18n from '@/utils/i18n';
import { FaBoxes, FaHistory, FaWrench } from 'react-icons/fa';
import { ContentSection } from '../../../../components/Layout/ContentSection';
import {
  ContextSidebarConfig,
  useRouteSidebar,
} from '@/components/SidebarContext';
import { Routes } from '@/utils/routes';

type DashboardLayoutProps = {
  title: string;
  children: React.ReactNode;
};

export const DashboardLayout = ({ title, children }: DashboardLayoutProps) => {
  const { eventAccountId, eventId } = useParams<{
    eventAccountId: string;
    eventId: string;
  }>();

  // Feed the events-dashboard navigation into the shared app-shell sidebar
  // instead of an inline Bootstrap nav. Using SidebarLink hrefs also routes
  // client-side (the old <a href> nav triggered full page reloads).
  const sidebarConfig: ContextSidebarConfig = useMemo(
    () => ({
      mode: 'grouped',
      groups: [
        {
          label: i18n.t('EventsDashboard:menu'),
          links: [
            {
              label: i18n.t('EventsDashboard:inventory'),
              href: Routes.eventsDashboardInventory(eventAccountId, eventId),
              icon: <FaBoxes />,
            },
            {
              label: i18n.t('EventsDashboard:fulfillments'),
              href: Routes.eventsDashboardFulfillments(eventAccountId, eventId),
              icon: <FaHistory />,
            },
            {
              label: i18n.t('EventsDashboard:settings'),
              href: Routes.eventsDashboardSettings(eventAccountId, eventId),
              icon: <FaWrench />,
            },
          ],
        },
      ],
    }),
    [eventAccountId, eventId],
  );

  useRouteSidebar(sidebarConfig, { id: 'events-dashboard' });

  return (
    <ContentSection title={title} collapsable={false}>
      {children}
    </ContentSection>
  );
};
